var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.397 3.391a1.32 1.32 0 0 0-1.862-.014L3.381 4.53l-.004.004a1.32 1.32 0 0 0 .014 1.862L5.154 8.16c.122.121.188.297.209.58.014.199.005.386-.005.6a13 13 0 0 0-.014.44c.045.664.417 1.263.991 1.6.596.378 1.375.3 1.884-.192l2.963-2.964.006-.005c.492-.509.57-1.288.191-1.884a2.02 2.02 0 0 0-1.645-.992q-.213.005-.392.015c-.215.01-.403.02-.603.005-.283-.02-.458-.087-.58-.208zm-1.16.7L4.09 5.234a.32.32 0 0 0 .005.45l.003.002 1.764 1.766c.363.363.47.818.498 1.214.02.258.005.554-.007.804l-.01.26a1.01 1.01 0 0 0 .525.802.53.53 0 0 0 .653-.061l2.95-2.951a.53.53 0 0 0 .049-.675 1.01 1.01 0 0 0-.79-.503l-.257.01c-.25.012-.548.027-.807.008-.396-.03-.85-.136-1.214-.5L5.687 4.096a.32.32 0 0 0-.45-.005",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.996 8.996a.5.5 0 0 1 .707 0l3.15 3.15a.5.5 0 0 1-.707.708l-3.15-3.15a.5.5 0 0 1 0-.708",
    clipRule: "evenodd"
  })));
};
export { SvgPin as ReactComponent };
export default __webpack_public_path__ + "1820c91c36e18b243cebc1242ad7a205.svg";